import React from 'react';
import GridProduct from '../../../CategoryPage/GridProduct';

const SuggestedTerm = ({ product, className = '', onClick = () => {} }) => {
  return <GridProduct onClick={e => onClick(e)} product={product} />;
};
export default SuggestedTerm;
